import { api, ExaminerOnlineMeetingProviderAccount, OnlineMeetingProviderAccount } from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';

const onlineMeetingProviderApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getOnlineMeetingProviderAccount: builder.query<ExaminerOnlineMeetingProviderAccount, number>({
      query: (examinerId) =>
        api.examinerOnlineMeetingProvider.getOnlineMeetingProviderAccount({ examinerId }),
      providesTags: ['OnlineMeetingProvider'],
    }),

    saveOnlineMeetingProviderAccount: builder.mutation<
      ExaminerOnlineMeetingProviderAccount,
      { examinerId: number; data: OnlineMeetingProviderAccount }
    >({
      query: ({ examinerId, data }) =>
        api.examinerOnlineMeetingProvider.saveOnlineMeetingProviderAccount({ examinerId }, data),
      invalidatesTags: ['OnlineMeetingProvider'],
    }),
  }),
});

export const {
  useGetOnlineMeetingProviderAccountQuery,
  useSaveOnlineMeetingProviderAccountMutation,
} = onlineMeetingProviderApi;
